import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[shDialogInsertion]',
    standalone: true
})
export class DialogInsertionDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
